import React from 'react'
import { Container } from '@offerzen/pinata-shame'

import ContentWithTOC from '../../components/ContentWithTOC'
import EmployerTermsAndConditions from '../../components/EmployerTermsAndConditions'
import TermsOfService from '../../components/EmployerTermsAndConditions/TermsOfService'
import Introduction from '../../components/EmployerTermsAndConditions/Introduction'
import AboutTerms from '../../components/EmployerTermsAndConditions/AboutTerms'

const EmployerTerms = () => (
  <Container>
    <ContentWithTOC>
      <EmployerTermsAndConditions>
        <Introduction />
        <AboutTerms />
        <TermsOfService />
      </EmployerTermsAndConditions>
    </ContentWithTOC>
  </Container>
)

export default EmployerTerms
